export default __webpack_public_path__ + "assets/montserrat-flag.png";